import { ref } from 'vue'

export function useStudentApi() {
  const loading = ref(false)
  const error = ref(null)

  const getStudents = async (url, params = {}) => {
    loading.value = true
    error.value = null
    
    try {
      const queryParams = new URLSearchParams()
      queryParams.append('withUsers', 'true')
      
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          queryParams.append(key, value)
        }
      })
      
      const response = await axios.get(`${url}?${queryParams.toString()}`)
      
      return {
        data: response.data.data || [],
        total: response.data.total || 0,
        currentPage: response.data.current_page || 1,
        lastPage: response.data.last_page || 1
      }
    } catch (err) {
      error.value = err.response?.data?.message || 'Error loading students'
      throw err
    } finally {
      loading.value = false
    }
  }

  const createStudent = async (url, studentData) => {
    loading.value = true
    error.value = null
    
    try {
      const response = await axios.post(url, studentData)
      return response.data
    } catch (err) {
      error.value = err.response?.data?.errors || 'Error creating student'
      throw err
    } finally {
      loading.value = false
    }
  }

  const validateEmailUnique = async (url, email) => {
    try {
      const response = await axios.post(url, { email })
      return response.data
    } catch (err) {
      console.error('Error validating email:', err)
      return false
    }
  }

  const searchAreas = async (url, query) => {
    try {
      const response = await axios.post(url, { query })
      return response.data.map(item => item.area.trim())
    } catch (err) {
      console.error('Error searching areas:', err)
      return []
    }
  }

  const uploadBulkFile = async (url, file, tipo = 'Estudiante') => {
    loading.value = true
    error.value = null
    
    try {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('tipo', tipo)
      
      const response = await axios.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      
      return response.data
    } catch (err) {
      error.value = err.response?.data?.message || 'Error uploading file'
      throw err
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    error,
    getStudents,
    createStudent,
    validateEmailUnique,
    searchAreas,
    uploadBulkFile
  }
}